import React from 'react';
import { useIntl } from 'react-intl';
import { TypedMemo } from '../../../common/types';
import { helpArticleUrl } from '../../../support/helpCenter/helpCenterUrl';
import { monthlyAddOnMessages } from '../../../settings/tabs/addOns/monthlyAddOnMessages';
import { storePlanMessage } from '../../utils/getUpgradeSessionErrorMessage';
import type { PlanStore } from './usePlanStore';
import styles from './StorePlanNote.module.scss';

/**
 * Shown in place of the checkout button when an app store bills the plan. The web cannot change a
 * store subscription, and a web checkout next to it would charge twice. The person changes the plan
 * in the store, or moves to web billing when the store plan ends (the help article).
 */
const StorePlanNoteComponent: React.FC<{ store: PlanStore }> = ({ store }) => {
  const intl = useIntl();
  return (
    <p className={styles.note} data-testid="upgrade-store-note">
      {storePlanMessage(store, intl)}{' '}
      <a
        href={helpArticleUrl('billing', 'app-store-and-google-play')}
        target="_blank"
        rel="noopener noreferrer"
        className={styles.link}
      >
        {intl.formatMessage(monthlyAddOnMessages.storeLink)}
      </a>
    </p>
  );
};

export const StorePlanNote = TypedMemo(StorePlanNoteComponent);
